import { Dictionary } from "../../../../../../react-core/Helpers/CommonHelper";
import { ContactType } from "../../../../../../Wrap/Constants/Enums/Domain/ContactType";
import { PhysicalAddressType } from "../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { CustomerPhoneNumberType } from "../../../../../../Wrap/Constants/Enums/Domain/CustomerPhoneNumberType";
import { EmailAddressType } from "../../../../../../Wrap/Constants/Enums/EmailAddressType";
import { RegulatoryCheckInfoType } from "../../../../../../Wrap/Constants/Enums/Customer/RegulatoryCheckInfoType";
import { RegulatoryCheckInfoResult } from "../../../../../../Wrap/Constants/Enums/Customer/RegulatoryCheckInfoResult";
import { RegulatoryCheckInfoStatus } from "../../../../../../Wrap/Constants/Enums/Customer/RegulatoryCheckInfoStatus";
import { AccountType } from "../../../../../../Wrap/Constants/Enums/Domain/AccountType";
import { AccountStatus } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { CustomerStatus } from "../../../../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { AdvancedSearchFilterType } from "../../../../../../Wrap/Constants/Enums/Search/AdvancedSearchFilterType";
import { RoleType } from "../../../../../../Wrap/Constants/Enums/RoleType";
import { CustomerType } from "../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { VulnerabilityCategory } from "../../../../../../Wrap/Constants/Enums/Customer/VulnerabilityCategory";
import { VulnerabilityType } from "../../../../../../Wrap/Constants/Enums/Customer/VulnerabilityType";
import { VulnerabilitySupportType } from "../../../../../../Wrap/Constants/Enums/Customer/VulnerabilitySupportType";
import { TrustRemovalReason } from "../../../../../../Wrap/Constants/Enums/Customer/TrustRemovalReason";
import { TrustMemberAction } from "../../../../../../Wrap/Constants/Enums/Customer/TrustMemberAction";
import { RoleStatus } from "../../../../../../Wrap/Constants/Enums/RoleStatus";

export enum ClientRecordTab {
    PersonalDetail = "Personal details",
    RegulatoryChecks = "Regulatory checks",
    Regulatory = "Regulatory",
    AddressDetail = "Address details",
    ContactDetail = "Contact details",
    PensionProtection = "Pension protection",
    OrganisationDetails = "Organisation details",
    TrustServicing = "Trust servicing",
    CompanyDetails = "Company details",
}

export const AllClientRecordTabs = [
    ClientRecordTab.PersonalDetail,
    ClientRecordTab.AddressDetail,
    ClientRecordTab.CompanyDetails,
    ClientRecordTab.ContactDetail,
    ClientRecordTab.OrganisationDetails,
    ClientRecordTab.PensionProtection,
    ClientRecordTab.Regulatory,
    ClientRecordTab.RegulatoryChecks,
    ClientRecordTab.TrustServicing,
];

export const IndividualClientRecordTabs = [
    ClientRecordTab.PersonalDetail,
    ClientRecordTab.RegulatoryChecks,
    ClientRecordTab.Regulatory,
    ClientRecordTab.AddressDetail,
    ClientRecordTab.ContactDetail,
];

export const OrganisationClientRecordTabs = [
    ClientRecordTab.OrganisationDetails,
    ClientRecordTab.TrustServicing,
    ClientRecordTab.RegulatoryChecks,
    ClientRecordTab.Regulatory,
    ClientRecordTab.AddressDetail,
    ClientRecordTab.ContactDetail,
];

export const CompanyClientRecordTabs = [
    ClientRecordTab.OrganisationDetails,
    ClientRecordTab.RegulatoryChecks,
    ClientRecordTab.Regulatory,
    ClientRecordTab.AddressDetail,
    ClientRecordTab.ContactDetail,
];

export const clientRecordTabContentArray = [
    ClientRecordTab.PersonalDetail,
    ClientRecordTab.RegulatoryChecks,
    ClientRecordTab.Regulatory,
    ClientRecordTab.AddressDetail,
    ClientRecordTab.ContactDetail,
    ClientRecordTab.PensionProtection,
    ClientRecordTab.OrganisationDetails,
    ClientRecordTab.TrustServicing,
];

export interface IClientTabProps {
    id: string;
    customerType?: CustomerType;
    hasReadWriteAccess: boolean;
}

export const AddressTypeMap = {
    [PhysicalAddressType.Registered]: "Primary registered",
    [PhysicalAddressType.Residential]: "Primary residential",
    [PhysicalAddressType.Postal]: "Correspondence ",
};

export const OccupationIndustry = [
    "Adult Entertainment",
    "Aerospace & Defense",
    "Agriculture & Fishing",
    "Air Freight & Logistics",
    "Airlines",
    "Armed Services",
    "Auto Components",
    "Automobiles",
    "Banks",
    "Beverages",
    "Biotechnology",
    "Building Products",
    "Call Centre",
    "Capital Markets",
    "Chemicals",
    "Civil Services",
    "Commercial Services & Supplies",
    "Communications Equipment",
    "Construction & Engineering",
    "Construction Materials",
    "Consumer Finance",
    "Containers & Packaging",
    "Data Not Available/Data Missing",
    "Distributors",
    "Diversified Financial Services",
    "Diversified Telecommunication Services",
    "Domestic Engineer",
    "Education",
    "Electric Utilities",
    "Electrical Equipment",
    "Electronic Equipment, Instruments & Components",
    "Emergency Services",
    "Energy Equipment & Services",
    "Entertainment",
    "Entertainment Sports",
    "Equity Real Estate Investment Trusts (REITs)",
    "Food & Staples Retailing",
    "Food Products",
    "Foreign worker agency  ",
    "Further Education",
    "Gas Utilities",
    "Health Care Equipment & Supplies",
    "Health Care Providers & Services",
    "Health Care Technology",
    "Hotels, Restaurants & Leisure",
    "Household Durables",
    "Household Products",
    "Independent Power and Renewable Electricity Producers",
    "Insurance",
    "Interactive Media & Services",
    "Internet & Direct Marketing Retail",
    "Investment",
    "IT Services",
    "Leisure Products",
    "Life Sciences Tools & Services",
    "Luxury Goods",
    "Machinery",
    "Marine",
    "Media",
    "Metals & Mining",
    "Military",
    "Money Service Business",
    "Mortgage Real Estate Investment Trusts (REITs)",
    "Multiline Retail",
    "Multi-Utilities",
    "Non-Profit Organizations (NPOs)",
    "Not Applicable",
    "Oil, Gas & Consumable Fuels",
    "Paper & Forest Products",
    "Pension Fund ",
    "Personal Products",
    "Pharmaceuticals",
    "Private Equity",
    "Professional Services",
    "Real Estate Management & Development",
    "Regulated Casino & Game",
    "Religious Organisation",
    "Resource Services",
    "Road & Rail",
    "Semiconductors & Semiconductor Equipment",
    "Software",
    "Sovereign Wealth Funds (SWFs)",
    "Specialty Retail",
    "State Pension Fund ",
    "Technology Hardware, Storage & Peripherals",
    "Textiles, & Apparel ",
    "Thrifts & Mortgage Finance",
    "Tobacco",
    "Trading Companies & Distributors",
    "Transportation Infrastructure",
    "Trust and Company Service Providers (TSCPs)",
    "Unlicensed Banks",
    "Unregulated Casino & Game",
    "Water Utilities",
    "Wireless Telecommunication Services",
];

export const RegulatoryCheckTypeMap = {
    [RegulatoryCheckInfoType.AML]: "AML",
    [RegulatoryCheckInfoType.PEP]: "PEP",
    [RegulatoryCheckInfoType.FinancialSanction]: "Subject to Sanctions",
    [RegulatoryCheckInfoType.HighRiskCustomer]: "High Risk Customer",
};

export const RegulatoryCheckResultTypeMap = {
    [RegulatoryCheckInfoResult.Pass]: "Pass",
    [RegulatoryCheckInfoResult.Fail]: "Failed",
    [RegulatoryCheckInfoResult.Refer]: "Refer",
    [RegulatoryCheckInfoResult.NonPep]: "Non-PEP",
    [RegulatoryCheckInfoResult.Pep]: "PEP",
    [RegulatoryCheckInfoResult.HighRiskPep]: "High-risk PEP",
    [RegulatoryCheckInfoResult.UnconfirmedPep]: "Unconfirmed PEP",
    [RegulatoryCheckInfoResult.NonSanction]: "Non-Sanction",
    [RegulatoryCheckInfoResult.Sanction]: "Sanction",
    [RegulatoryCheckInfoResult.UnconfirmedSanction]: "Unconfirmed Sanction",
    [RegulatoryCheckInfoResult.NotHighRisk]: "Not High Risk",
    [RegulatoryCheckInfoResult.HighRisk]: "High Risk",
};

export const RegulatoryCheckInfoTypeMap = {
    [RegulatoryCheckInfoStatus.NotVetted]: "Not vetted",
    [RegulatoryCheckInfoStatus.Vetted]: "Vetted",
};

export const PensionProtectionMapForDrawdown: Dictionary[] = [
    { key: "PensionEnhancedProtectionDetails", value: "Is this client entitled to enhanced protection?" },
    { key: "PensionPrimaryProtectionDetails", value: "Is this client entitled to primary protection?" },
    { key: "PensionFixedProtectionDetails", value: "Is this client entitled to fixed protection 2012?" },
    { key: "PensionFixed2014ProtectionDetails", value: "Is this client entitled to fixed protection 2014?" },
    { key: "PensionFixed2016ProtectionDetails", value: "Is this client entitled to fixed protection 2016?" },
    { key: "PensionIndividual2014ProtectionDetails", value: "Is this client entitled to individual protection 2014?" },
    { key: "PensionIndividual2016ProtectionDetails", value: "Is this client entitled to individual protection 2016?" },
    {
        key: "PensionRelevantOverseasProtectionDetails",
        value:
            "Is this client entitled to a lifetime allowance enhancement factor arising from being a relevant overseas individual?",
    },
    {
        key: "PensionQropsProtectionDetails",
        value:
            "Is this client entitled to a lifetime allowance enhancement factor following a transfer from a recognised overseas pension scheme?",
    },
    {
        key: "PensionCreditProtectionDetails",
        value:
            "Is this client entitled to a lifetime allowance enhancement factor following receipt of a pension credit?",
    },
    {
        key: "PensionSchemeSpecificProtectionDetails",
        value: "Is one or more of the transfers part of a block transfer?",
    },
    { key: "PensionTransitionalLumpSumProtectionDetails", value: "Does the client have a Transitional Tax-Free Amount Certificate?" },
];

export const PensionProtectionMap: Dictionary[] = [
    { key: "PensionEnhancedProtectionDetails", value: "Is this client entitled to enhanced protection?" },
    { key: "PensionPrimaryProtectionDetails", value: "Is this client entitled to primary protection?" },
    { key: "PensionFixedProtectionDetails", value: "Is this client entitled to fixed protection 2012?" },
    { key: "PensionFixed2014ProtectionDetails", value: "Is this client entitled to fixed protection 2014?" },
    { key: "PensionFixed2016ProtectionDetails", value: "Is this client entitled to fixed protection 2016?" },
    { key: "PensionIndividual2014ProtectionDetails", value: "Is this client entitled to individual protection 2014?" },
    { key: "PensionIndividual2016ProtectionDetails", value: "Is this client entitled to individual protection 2016?" },
    {
        key: "PensionRelevantOverseasProtectionDetails",
        value:
            "Is this client entitled to a lifetime allowance enhancement factor arising from being a relevant overseas individual?",
    },
    {
        key: "PensionQropsProtectionDetails",
        value:
            "Is this client entitled to a lifetime allowance enhancement factor following a transfer from a recognised overseas pension scheme?",
    },
    {
        key: "PensionCreditProtectionDetails",
        value:
            "Is this client entitled to a lifetime allowance enhancement factor following receipt of a pension credit?",
    },
    {
        key: "PensionSchemeSpecificProtectionDetails",
        value: "Is one or more of the transfers part of a block transfer?",
    },
    {
        key: "Enhanced",
        value: "Is this client entitled to enhanced protection?",
    },
    {
        key: "Fixed",
        value: "no",
    },
    {
        key: "Individual",
        value: "no",
    },
    {
        key: "LifetimeAllowanceEnhancements",
        value: "no",
    },
    {
        key: "Primary",
        value: "Is this client entitled to primary protection?",
    },
    {
        key: "PensionSchemeSpecificProtection",
        value: "Is one or more of the transfers part of a block transfer?",
    }];

export const PensionProtectionInformation = {
    enhancedProtectionAppliedBefore15032023WithPCLS: (pclsEntitlement: number) => 
        `Enhanced Protection applied for before 15 March 2023 with a PCLS entitlement of ${pclsEntitlement}%.`,
    enhancedProtectionAppliedBefore15032023WithNoPCLS: 
        "Enhanced Protection applied for before 15 March 2023 with No PCLS Protection.",
    enhancedProtectionAppliedOnOrAfter15032023WithPCLS: (pclsEntitlement: number) =>
        `Enhanced Protection applied for on or after 15 March 2023 with a PCLS entitlement of ${pclsEntitlement}%.`,
    enhancedProtectionAppliedOnOrAfter15032023WithNoPCLS:
        "Enhanced Protection applied for on or after 15 March 2023 with No PCLS Protection.",
    fixedProtection2016AppliedBefore15032023:
        "Fixed Protection 2016 applied for before 15 March 2023.",
    fixedProtection2016AppliedOnOrAfter15032023:
        "Fixed Protection 2016 applied for on or after 15 March 2023.",
    fixedProtection2014AppliedBefore15032023:
        "Fixed Protection 2014 applied for before 15 March 2023.",
    fixedProtection2014AppliedOnOrAfter15032023:
        "Fixed Protection 2014 applied for on or after 15 March 2023.",
    fixedProtection2012AppliedBefore15032023:
        "Fixed Protection 2012 applied for before 15 March 2023.",
    fixedProtection2012AppliedOnOrAfter15032023:
        "Fixed Protection 2012 applied for on or after 15 March 2023.",
};

export const GrantedTypesMap = {
    IsPre6Apr2012: "Before 6 April 2012",
    IsPre6Apr2014: "Between 6 April 2012 and 5 April 2014",
    IsPre6Apr2016: "Between 6 April 2014 and 5 April 2016",
    IsPost6Apr2016: "On or after 6 April 2016",
};

export const GrantedTypes = ["IsPre6Apr2012", "IsPre6Apr2014", "IsPre6Apr2016", "IsPost6Apr2016"];

export const PhoneNumberTypeArray = [
    CustomerPhoneNumberType.Business,
    CustomerPhoneNumberType.Mobile,
    CustomerPhoneNumberType.Home,
];

export const PhoneNumberTypeMap = {
    [CustomerPhoneNumberType.Business]: "Work",
    [CustomerPhoneNumberType.Mobile]: "Mobile",
    [CustomerPhoneNumberType.Home]: "Home",
};

export const EmailTypeMap = {
    [EmailAddressType.Primary]: "primary",
    [EmailAddressType.Other]: "other",
};

export const ContactTypeMap = {
    [ContactType.Email]: "Email",
    [ContactType.Phone]: "Phone",
    [ContactType.Post]: "Post",
    [ContactType.Sms]: "SMS",
};

export const question = {
    consent:
        "I confirm that the customer has given consent to store special category data relating to health as part of executing the contract",
};

export const accountTypeMap = {
    [AccountType.Joint]: "Joint",
    [AccountType.Individual]: "Individual",
    [AccountType.Trust]: "Trust",
    [AccountType.Consolidated]: "Consolidated",
};

export const accountStatusMap = {
    [AccountStatus.Active]: "Wrap: Active",
    [AccountStatus.PendingTC]: "Wrap: Pending Terms & Conditions",
    [AccountStatus.PendingCompliance]: "Wrap: Pending Compliance Check",
    [AccountStatus.Suspended]: "Wrap: Suspended",
    [AccountStatus.Deceased]: "Wrap: Deceased",
    [AccountStatus.DeceasedClosed]: "Wrap: Deceased-Closed",
    [AccountStatus.InActive]: "Wrap: Inactive",
    [AccountStatus.Closing]: "Wrap: Closing",
    [AccountStatus.Closed]: "Wrap: Closed",
    [AccountStatus.RecordOnly]: "Non-Wrap: Record Only",
    [AccountStatus.Potential]: "Non-Wrap: Potential",
    [AccountStatus.Introductory]: "Non-Wrap: Introductor Pack",
    [AccountStatus.Targeted]: "Non-Wrap: Targeted",
    [AccountStatus.InProgress]: "Non-Wrap: In Progress",
    [AccountStatus.Submitted]: "Non-Wrap: Submitted",
    [AccountStatus.Rejected]: "Non-Wrap: Rejected",
};

export const ALL = 98;
export const ALL_WRAP = 99;
export const ALL_NON_WRAP = 100;

export const wrapStatuses = [
    AccountStatus.Active,
    AccountStatus.PendingTC,
    AccountStatus.PendingCompliance,
    AccountStatus.Suspended,
    AccountStatus.Deceased,
    AccountStatus.DeceasedClosed,
    AccountStatus.Closing,
    AccountStatus.Closed,
];

export const nonWrapStatuses = [
    AccountStatus.RecordOnly,
    AccountStatus.Potential,
    AccountStatus.Introductory,
    AccountStatus.Targeted,
    AccountStatus.Submitted,
    AccountStatus.Rejected,
];

export const getStatus = (status) => {
    switch (status) {
        case ALL:
            return wrapStatuses.concat(nonWrapStatuses);
        case ALL_WRAP:
            return wrapStatuses;
        case ALL_NON_WRAP:
            return nonWrapStatuses;
        case null:
            return null;
        default:
            return [status];
    }
};

export const customerStatusMap = {
    [CustomerStatus.NotSpecified]: "All",
    [CustomerStatus.Active]: "Active",
    [CustomerStatus.Inactive]: "Inactive",
    [CustomerStatus.Deceased]: "Deceased",
};

export const roleTypeMap = {
    [RoleType.IndividualAccountHolder]: "Individual account holder",
    [RoleType.JointAccountHolder]: "Joint account holder",
    [RoleType.TrustAccountHolder]: "Trust account holder",
    [RoleType.LifeAssured]: "Life assured",
    [RoleType.AdditionalLifeAssured]: "Additional life assured",
    [RoleType.Trustee]: "Trustee",
    [RoleType.AdditionalSignatory]: "Signatory",
    [RoleType.Beneficiary]: "Beneficiary",
    [RoleType.RegisteredContact]: "Registered contact",
    [RoleType.LegalRepresentative]: "Legal representative/Executor",
    [RoleType.PowerOfAttorney]: "Power of attorney",
    [RoleType.LetterOfAuthority]: "Letter of authority",
    [RoleType.Employer]: "Employer",
    [RoleType.ExSpouse]: "Ex spouse",
    [RoleType.Dependent]: "Dependent",
    [RoleType.Nominee]: "Nominee",
    [RoleType.ThirdPartyPayer]: "Third party payer",
    [RoleType.PartnerOfAccountHolder]: "Partner of Account holder",
    [RoleType.AccountAccessLegacy]: "Account access legacy",
    [RoleType.AccountAccess]: "Account access",
    [RoleType.Settlor]: "Settlor",
    [RoleType.AdditionalBeneficiary]: "Additional beneficiary",
    [RoleType.TrustAppointer]: "Trust appointer",
    [RoleType.ControllingPerson]: "Controlling person",
    [RoleType.TrustProtector]: "Trust protector",
    [RoleType.DirectorController]: "Director controller",
    [RoleType.ShareholderGT25]: "Shareholder >25%",
};

export const productWrapperOptions = [
    {
        label: "ISA Stocks & Shares",
        type: SubAccountType.StocksIsa,
    },
    {
        label: "Self-Invested Personal Pension (SIPP)",
        type: SubAccountType.Sipp,
    },
    {
        label: "Personal Portfolio",
        type: SubAccountType.InvestmentAccount,
    },
    {
        label: "Offshore Bonds",
        type: SubAccountType.OffshoreBond,
    },
    {
        label: "Onshore Bonds",
        type: SubAccountType.OnshoreBond,
    },
    {
        label: "Aberdeen SIPP",
        type: SubAccountType.Npr,
    },
    {
        label: "Junior SIPP",
        type: SubAccountType.JuniorSipp,
    },
];

export const advancedSearchFilterTypeArray = [
    AdvancedSearchFilterType.Wrapper,
    AdvancedSearchFilterType.Mandate,
    AdvancedSearchFilterType.RegularPayment,
    AdvancedSearchFilterType.RegularWithdrawal,
];

export const advancedSearchFilterTypeMap = {
    [AdvancedSearchFilterType.Wrapper]: "Wrapper",
    [AdvancedSearchFilterType.Mandate]: "Mandate",
    [AdvancedSearchFilterType.RegularPayment]: "Regular payments",
    [AdvancedSearchFilterType.RegularWithdrawal]: "Regular withdrawals",
};

export enum ContactPreferenceOption {
    Marketing,
    Contact,
    Survey,
    Essentials,
    AdditionalOffers,
    ThirdPartyOffers,
}

export const ContactPereferenceOptionsArray = [
    ContactPreferenceOption.Marketing,
    ContactPreferenceOption.Contact,
    ContactPreferenceOption.Survey,
    ContactPreferenceOption.Essentials,
    ContactPreferenceOption.AdditionalOffers,
    ContactPreferenceOption.ThirdPartyOffers,
];

export const ContactPreferenceOptionsMap = {
    [ContactPreferenceOption.Marketing]: "Marketing",
    [ContactPreferenceOption.Contact]: "Contact",
    [ContactPreferenceOption.Survey]: "Survey",
    [ContactPreferenceOption.Essentials]: "Essentials",
    [ContactPreferenceOption.AdditionalOffers]: "Additional offers",
    [ContactPreferenceOption.ThirdPartyOffers]: "Third party offers",
};

export const VulnerabilityEndReasons = ["Amended", "Expired", "No longer applicable", "Added in error"];

export const VulnerableCategoryArray = [
    VulnerabilityCategory.ChannelAccess,
    VulnerabilityCategory.PhysicalMental,
    VulnerabilityCategory.Capability,
    VulnerabilityCategory.MoneyWorries,
    VulnerabilityCategory.LifeEvents,
    VulnerabilityCategory.Complex,
];

export const VulnerableCategoryMap = {
    [VulnerabilityCategory.ChannelAccess]: "Channel & access",
    [VulnerabilityCategory.PhysicalMental]: "Physical and mental health",
    [VulnerabilityCategory.Capability]: "Capability",
    [VulnerabilityCategory.MoneyWorries]: "Money worries",
    [VulnerabilityCategory.LifeEvents]: "Life events",
    [VulnerabilityCategory.Complex]: "Complex",
};

export const VulnerabilityTypeMap = {
    [VulnerabilityType.NotSpecified]: "Not specified",
    [VulnerabilityType.Hearing]: "Hearing",
    [VulnerabilityType.Sight]: "Sight",
    [VulnerabilityType.Speech]: "Speech",
    [VulnerabilityType.SevereIllness]: "Severe or long term illness",
    [VulnerabilityType.PhysicalDisability]: "Physical disability",
    [VulnerabilityType.MentalHealth]: "Poor mental health",
    [VulnerabilityType.MemoryLoss]: "Memory loss",
    [VulnerabilityType.Dyslexia]: "Dyslexia",
    [VulnerabilityType.LowKnowledge]: "Low knowledge or confidence in managing financial matters",
    [VulnerabilityType.PoorLiteracy]: "Poor literacy or numerical skills",
    [VulnerabilityType.PoorDigital]: "Poor or non-existent digital skills",
    [VulnerabilityType.LearningImpairments]: "Learning impairments",
    [VulnerabilityType.LowEnglish]: "Low English language skills",
    [VulnerabilityType.FinancialHardship]: "Financial hardship",
    [VulnerabilityType.PreviousFraud]: "Previous fraud exposure",
    [VulnerabilityType.Bereavement]: "Bereavement",
    [VulnerabilityType.Redundancy]: "Redundancy",
    [VulnerabilityType.Relationship]: "Divorce / Relationship breakdown",
    [VulnerabilityType.Birth]: "Birth of a child",
    [VulnerabilityType.HouseMove]: "House move",
    [VulnerabilityType.CaringResponsibilities]: "Caring responsibilities",
    [VulnerabilityType.Retirement]: "Retirement",
    [VulnerabilityType.ChangedGender]: "Change of gender",
    [VulnerabilityType.NonStandard]: "Non standard - prison/Ex-offnder/Refugees",
    [VulnerabilityType.ThreatToLife]: "Threat to life",
    [VulnerabilityType.RiskOfFinancialLoss]: "Risk of significant financial loss",
    [VulnerabilityType.Complex]: "Particularly complex cas",
};

export const VulnerabilitySupportTypeMap = {
    [VulnerabilitySupportType.NotSpecified]: "Not specified",
    [VulnerabilitySupportType.UnableToUsePhone]: "Unable to use phone - use other contact methods",
    [VulnerabilitySupportType.UnableToUseDigital]: "Unable to use digital - use other contact methods",
    [VulnerabilitySupportType.UnableToUseWritten]: "Unable to use written channel - use other contact methods",
    [VulnerabilitySupportType.ThirdPartyMandate]: "3rd party mandate in place",
    [VulnerabilitySupportType.PowerOfAttorney]: "Power of Attorney in place",
    [VulnerabilitySupportType.CourtProtection]: "Court Protection Order/Guardianship in place",
    [VulnerabilitySupportType.DedicatedContact]: "Dedicated contact within Standard Life",
    [VulnerabilitySupportType.SignLanguage]: "Signpost external suppor",
    [VulnerabilitySupportType.NextGenText]: "Next Generation Text required",
    [VulnerabilitySupportType.TextRelay]: "Text relay required",
    [VulnerabilitySupportType.ExternalAccessibilitySupport]: "Signpost external accessibility support",
    [VulnerabilitySupportType.SpeakSlower]: "Speak slower / talk Louder",
    [VulnerabilitySupportType.TakeTime]: "Take time and adapt call to situation",
    [VulnerabilitySupportType.AudiCD]: "Audio CD required",
    [VulnerabilitySupportType.Braille]: "Braille required",
    [VulnerabilitySupportType.LargeFont]: "Large Font required",
    [VulnerabilitySupportType.VoiceBox]: "Electronic voice box required",
    [VulnerabilitySupportType.ExtraTime]: "Requires extra time to communicate",
    [VulnerabilitySupportType.IllHealthProcess]: "Ill health process applicable",
    [VulnerabilitySupportType.SeriousIllHealthProcess]: "Serious ill health process applicable",
    [VulnerabilitySupportType.SummaryInWriting]: "Summary of conversations in writing required",
    [VulnerabilitySupportType.ExternalHealthSupport]: "Signpost external health support",
    [VulnerabilitySupportType.ExternalCapabilitySupport]: "Signpost external capability support",
    [VulnerabilitySupportType.FamilyMemberIntepreter]: "Family member interpreter required",
    [VulnerabilitySupportType.LionbridgeTranslator]: "Lionbridge language translator required",
    [VulnerabilitySupportType.PrioritiseMoneyOut]: "Prioritise money out - needs money urgently",
    [VulnerabilitySupportType.EscalationRequired]: "Escalation required - no solution available",
    [VulnerabilitySupportType.ExternalFinancialSupport]: "Signpost external financial support",
    [VulnerabilitySupportType.ReferToFraudRep]: "Refer to local Fraud Rep",
    [VulnerabilitySupportType.ExternalSupport]: "Signpost external support",
    [VulnerabilitySupportType.CheckPreferences]: "Be aware of and check preferences with customer",
    [VulnerabilitySupportType.PrisonProcess]: "Prison process and letters required",
    [VulnerabilitySupportType.CommunicationRequirements]: "Communication required",
    [VulnerabilitySupportType.TrustedPerson]: "Trusted person",
};

export const organisationTypeArray = [
    CustomerType.NotSpecified,
    CustomerType.Trust,
    CustomerType.CorporateTrust,
    CustomerType.Company,
];

export const organisationTypeMap = {
    [CustomerType.NotSpecified]: "All",
    [CustomerType.CorporateTrust]: "Corporate trust",
    [CustomerType.Trust]: "Trust",
    [CustomerType.Company]: "Company",
};

export const organisationStatusMap = {
    [CustomerStatus.NotSpecified]: "All",
    [CustomerStatus.Active]: "Active",
    [CustomerStatus.Inactive]: "Inactive",
};

export const RemoveReasonTypeMap = {
    [TrustRemovalReason.NotSpecified]: "",
    [TrustRemovalReason.Death]: "Deceased",
    [TrustRemovalReason.Resignation]: "Resignation",
    [TrustRemovalReason.Retirement]: "Retirement",
    [TrustRemovalReason.Removed]: "Removed",
};

export const PendingMembersWarningMessage = {
    pendingRemoval: "Cannot remove Trust member - Pending removal as Trustee",
    pendingAdd: "Cannot remove Trust member - Pending addition as Trustee",
    pendingDeath: "Cannot remove Trust member - member has a pending status of death on another trust account",
};

export const TrustMemberActionMap = {
    [TrustMemberAction.NotSpecified]: "",
    [TrustMemberAction.ActiveAsBeneiciary]: "Active as beneficiary",
    [TrustMemberAction.ActiveAsSettlor]: "Active as settlor",
    [TrustMemberAction.ActiveAsSignatory]: "Active as signatory",
    [TrustMemberAction.ActiveAsTrustee]: "Active as trustee",
    [TrustMemberAction.AddedAsBeneficiary]: "Added as beneficiary",
    [TrustMemberAction.Deceased]: "Deceased",
    [TrustMemberAction.InActiveAsTrustee]: "Inactive as trustee",
    [TrustMemberAction.RemovedAsBeneficiary]: "Remove as beneficiary",
    [TrustMemberAction.TrusteeAdditionAuthorised]: "Authorised and added as Trustee",
    [TrustMemberAction.TrusteeAdditionRejected]: "Authorisation rejected for addition as Trustee",
    [TrustMemberAction.TrusteeRemovalRejected]: "Authorisation rejected for removal as Trustee",
    [TrustMemberAction.PendingAuthorisationAsTrustee]: "Pending authorisation as trustee",
    [TrustMemberAction.PendingRemovalAsTrustee]: "Pending removal as trustee",
};

export const TrustMemberDeathValidationMsg = {
    correspondence: ". Before you remove this Trustee, you must select another address for correspondence to go to.",
    lastFlexibleBeneficiary: ". At least 1 Beneficiary is required for a Flexible trust account.",
    hasOutstandingRequests: ". This Trustee already has an outstanding request for removal.",
    BeneficiaryWithZeroPercentage: ". Before setting client to Deceased, update their share of Trust to 0.00%.",
};

export const DimCompanyName = "DIM Company";

export const RoleStatusMap = {
    [RoleStatus.Active]: "Active",
    [RoleStatus.Inactive]: "Inactive",
};
